import React from 'react'

const ArrowIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M16 7H22V13" stroke="#1DBF73" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M22 7L13.5 15.5L8.5 10.5L2 17" stroke="#1DBF73" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default ArrowIcon